<template>
  <div class="express-checkout-cart">
    <div class="cart-header">
      <h3 class="cart-title">Uw bestelling</h3>
      <p class="product">{{ selectedProduct.name }}</p>
      <p v-if="selectedDuration" class="duration">
        {{ productDurationsLabels[selectedDuration] }} | {{ periodPricesAfterDiscount[selectedDuration] | localize }} / maand
      </p>
    </div>
    <ul class="cart-list">
      <li class="subtotal">
        <span>Subtotaal</span>
        <span>{{ totalPrice | localize }}</span>
      </li>
      <li class="discount">
        <span>Korting</span>
        <span v-if="discount.percentage">
          {{ discount.percentage }}%
        </span>
        <span v-else-if="discount.value">
          {{ parseFloat(discount.value) | localize }}
        </span>
        <span v-else>-</span>
      </li>
      <li class="total">
        <span>Totaal</span>
        <span>{{ totalPriceAfterDiscount | localize }}</span>
      </li>
    </ul>
  </div>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'

  export default {
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapGetters } = createNamespacedHelpers(namespace)
      // computed 
      this.$options.computed = {
        ...(this.$options.computed || {}),
        ...mapGetters([
          'selectedProduct',
          'productDurationsLabels',
          'selectedDuration',
          'totalPrice',
          'totalPriceAfterDiscount',
          'periodPricesAfterDiscount',
          'discount'
        ])
      }
    }
  }
</script>

<style lang="scss" scoped>

  .express-checkout-cart {
    background-color: var(--ec-gray-lighter, lighten(black, 97));
    padding: 1.5em;
    border-radius: var(--ec-border-radius, 3px);
  }

  .cart-header {
    padding-bottom: 1.5em;
    margin-bottom: 1.5em;
    border-bottom: 1px solid var(--ec-gray-light, lighten(black, 85));
  }

  .cart-title {
    font-size: 1em;
    padding-bottom: 1em;
  }

  .product {
    padding-bottom: .25em;
  }

  .cart-list {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: .5em;
    }

  }

  .duration, .subtotal {
    color: var(--ec-gray, lighten(black, 35));
  }

  .discount {
    color: var(--ec-red, red);
  }

  .total {
    font-weight: 700;
  }

</style>